/* What a quantity is worth and what changing it means, kept in one place: the
   cart screen, the listing screens and the cart's own running total each used
   to decide it for themselves, and each got it wrong in its own way. */

/* What a line contributes to the total on screen, so taking it out subtracts
   exactly what putting it in added. Left unfloored in one of the two places
   that counted it, a line priced 10.5 took 21 off a total it had only added 20
   to. */
export const lineTotal = (item) => Math.floor(item?.price || 0) * (item?.quantity || 0);

/* Stepping the quantity down to zero is how the cart table says "take the line
   out" - it is where the stepper stops, and there is nothing else it could mean
   on a cart. It used to be sent to the API as a quantity, which refuses
   anything below one, so the client got a generic failure instead.

   A cleared box is not a zero: antd reports it as null - and as an empty string
   once typed into and emptied again - while the client is part way through
   retyping a number, and deleting the row out from under them mid-edit is
   exactly what this avoids. Blankness is settled before the number is read,
   because `Number('')` is 0 and would otherwise read as a removal. */
export const quantityEdit = (quantity) => {
  const blank = quantity === null || quantity === undefined || quantity === '';
  const parsed = blank ? NaN : Number(quantity);

  if (!Number.isFinite(parsed)) return 'ignore';
  return parsed <= 0 ? 'remove' : 'add';
};

/* Whether a line in a listing screen is one of the items the add button sends.
   Read as a number: the quantity column is a stepper, which hands back `0`, not
   the string this was once compared against - so a line stepped down to zero
   stayed selected, went to the API as a quantity it refuses, and took the whole
   add down with it. */
export const isSelectedQuantity = (quantity) => Number(quantity) > 0;
